import React from 'react';
import Header from './components/Header/Header';
import AboutMe from './components/AboutSection/AboutMe';
import ProjectSection from './components/ProjectSection/ProjectSection';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className='App'>
      <Header />
      <ProjectSection />
      <AboutMe />
      <Footer />
    </div>
  );
}

export default App;